import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { AiTrialSuccessDialogComponent } from './ai-trial-success-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule
	],
	declarations: [
		AiTrialSuccessDialogComponent
	],
	exports: [
		AiTrialSuccessDialogComponent
	]
})
export class AiTrialSuccessDialogModule {}
